import { ref } from 'vue';
import { useHttp, useToasts } from '@/composables';
import { HttpStatusCode } from 'axios';

export function useEntityRestorer(entityName, loadEntities) {
  const restoring = ref(false);
  const entityToRestore = ref(null);
  const toasts = useToasts();

  const restoreEntity = async () => {
    if (entityToRestore.value) {

      restoring.value = true;

      const response = await useHttp().post(`/${entityName}/${entityToRestore.value.id}/restore`);

      // Capitalizes the first letter and removes the trailing s
      let singularName = entityName;
      if (singularName.endsWith('ies')) {
        singularName = singularName.slice(0, -3) + 'y';
      } else if (singularName.endsWith('s')) {
        singularName = singularName.slice(0, -1);
      }

      const captilizedName = singularName.charAt(0).toUpperCase() + singularName.slice(1);

      if (response.statusCode === HttpStatusCode.Ok) {
        toasts.success(`${captilizedName} successfully restored`);
        entityToRestore.value = null;
        loadEntities();
      } else {
        toasts.error(`Could not restore ${captilizedName}`);
      }

      restoring.value = false;
    }
  };

  return {
    restoring,
    entityToRestore,
    restoreEntity,
  };
}
